<template>
  <div class="estimateCard">
    <h3 class="title title_order">预估结果</h3>
    <a-tabs style="padding: 0 20px;" :activeKey="tabKey" @change="tabsChange">
      <a-tab-pane :key="0" tab="生长性能">
        <growth-properties :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :predictionTypeCode='predictionTypeCode' />
      </a-tab-pane>
      <a-tab-pane :key="1" tab="氨基酸、钙、磷需要量">
        <amino-acid :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details="details" :predictionTypeCode='predictionTypeCode' />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import {baseFeild} from '../../EstimateConfig/estimateConfig'
import GrowthProperties from './EstimateResults/GrowthProperties.vue'
import AminoAcid from './EstimateResults/AminoAcid.vue'

export default {
  props:['isAdd','details'],
  components:{
      GrowthProperties,AminoAcid
  },
  data(){
    return{
      baseFeild,
      resId:'',
      infor: {},
      tabKey: 0,
      predictionTypeCode: '',
      // 预估结果显示控制
      // 生长育肥猪：growingFinishing；断奶仔猪：startingPigs
      arrGrowth: ['growingFinishing','startingPigs'],
      arrAmino: ['growingFinishing'],
      arrMineral: ['growingFinishing'],
      arrVitamin: ['growingFinishing'],
      arrCharts: ['growingFinishing'],
    }
  },
  computed:{
    showGrowth(){ // 生长性能
      return this.arrGrowth.includes(this.predictionTypeCode)
    },
    showAmino(){ // 氨基酸
      return this.arrAmino.includes(this.predictionTypeCode)
    },
  },
  methods:{
    init({id,predictionTypeCode}){
      if(id) this.resId = id  //保存id
      if(predictionTypeCode) this.predictionTypeCode = predictionTypeCode
    },
    tabsChange(val){
      this.tabKey = val
    }
  },

}
</script>